import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AgroLayoutReducer {
  currentTab: string,
}

const initialState: AgroLayoutReducer = {
  currentTab: 'water-balance-sequential',
};

export const agroLayoutSlice = createSlice({
  name: 'agroLayout',
  initialState,
  reducers: {
    setCurrentTab: (state, action: PayloadAction<string>) => {
      state.currentTab = action.payload;
    },
  },
});

export const selectAgroLayoutCurrentTab = (state: any) => (
  state.agroLayout.currentTab
);

export const {
  setCurrentTab,
} = agroLayoutSlice.actions;

export default agroLayoutSlice.reducer;
